import React from 'react';
import styles from '../styles/Projects.module.css';
import ImageGrid from './ImageGrid';
import Copyright from './Copyright';

const Projects: React.FC = () => {
    const imagePaths = [
        './grid-1.png',
        './grid-2.png',
        './grid-3.png',
        './grid-4.png',
    ];
  return (
    <div className={styles.container}>
      <div className={styles.separator}></div>
      <p className={styles.title}>Projects</p>
      <div className={styles.textImageContainer}>
        <div className={styles.textContainer}>
          <p className={styles.text}>Split Heritage strives to ensure the preservation and restoration of works of art and the traditions of Split's culture. The organization is dedicated to securing a future for many historical pieces that are currently endangered by environmental and economic factors affecting the city.</p>
        </div>
        <div className={styles.imageGridContainer}>
          <ImageGrid images={imagePaths} />
        </div>
      </div> 
      <Copyright />
    </div>
  );
};

export default Projects;